module.exports = __webpack_public_path__ + "static/second-32d3f6a4b0fb4a4139b4deef425c1fdf.jpg";